import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { AuthContext } from "../../context/authContext";
import AppContent from "../templates/wrapper/AppContent";
import ChangePhoneNumberForm from "../organisms/forms/changePhoneNumber/ChangePhoneNumberForm";
import { useToast } from "../../hooks/useToast";
import VerificationForm from "../organisms/forms/verification/VerificationForm";
import { formattedPhone, getCountryCode } from "../../helpers/utils";
import { useNavigate } from "react-router-dom";
import { phoneCode } from "../../helpers/phoneCode";

export default function ChangePhoneNumber() {
  const { t } = useTranslation();
  const authContext = useContext(AuthContext);
  const navigate = useNavigate();
  const { showToast } = useToast();
  const countryCode = getCountryCode();

  const [isVerificationStage, setIsVerificationStage] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");

  const onSubmit = async (values) => {
    try {
      setPhoneNumber(values.phone_number);
      const attr = {
        Name: "phone_number",
        Value: formattedPhone(values.phone_number, countryCode),
      };
      await authContext.setAttribute(attr);
      await authContext.getAttributeVerificationCode("phone_number");
      showToast("success", t("changeProfile.transactionSuccessful"));
      setIsVerificationStage(true);
    } catch (error) {
      showToast("error", String(error?.message));
    }
  };

  const handleClickVerifyWithDifferentEmail = () => {
    setIsVerificationStage(false);
  };

  const handleGetCode = async ({ otp }) => {
    try {
      await authContext.verifyAttribute(otp, "phone_number");
      await authContext.refreshSession();
      authContext.signOut(false);
      localStorage.setItem("navigateMessage", "phoneNumberChanged");
      navigate("/");
    } catch (error) {
      showToast("error", t("otpLogin.codeErrorConfirmCode"));
    }
  };

  const handleResend = async () => {
    await onSubmit({ phone_number: phoneNumber });
  };

  return (
    <>
      {!isVerificationStage ? (
        <AppContent title={t("home.phoneNumber")}>
          <ChangePhoneNumberForm onSubmit={onSubmit} />
        </AppContent>
      ) : (
        <AppContent isConfirmedPage>
          <div className="py-12">
            <VerificationForm
              title={t("changePhone.confirmPhoneNumber")}
              description={`${t("changePhone.verifyPhoneNumber")} ${
                phoneCode.find((item) => item.code === countryCode)?.dial_code
              } ${phoneNumber} ${t("changePhone.sentCode")}`}
              isPhoneNumberVerification={true}
              handleGetCode={handleGetCode}
              handleResend={handleResend}
              handleClickVerifyWithDifferentEmail={
                handleClickVerifyWithDifferentEmail
              }
            />
          </div>
        </AppContent>
      )}
    </>
  );
}
